var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-recommend" }, [
    _c("h3", { staticClass: "recommend-title" }, [
      _vm._v(_vm._s(_vm.appRecommend.title))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "recommend-subtitle" }, [
      _vm._v(_vm._s(_vm.appRecommend.subTitle))
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "recommend-list dp-f" },
      _vm._l(_vm.appRecommend.blocks, function(block) {
        return _c(
          "li",
          { key: block.name, staticClass: "rd-block", style: _vm.blockStyle },
          [
            block.logo
              ? _c("div", { staticClass: "rd-block-logo" }, [
                  _c("img", { attrs: { src: block.logo, alt: "" } })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "rd-block-text", style: _vm.textStyle }, [
              _vm._v(_vm._s(block.text))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "rd-block-name" }, [
              _vm._v(_vm._s(block.name))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "rd-block-company" }, [
              _vm._v(_vm._s(block.company))
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }